// FatturaPA v1.2.2 SDI fiscal constants + Italian geographical data.

// --- Aliquote IVA valide per FatturaPA
export const ALIQUOTE_IVA = [
  { value: 22, label: "22% — Ordinaria" },
  { value: 10, label: "10% — Ridotta" },
  { value: 5, label: "5% — Minima" },
  { value: 4, label: "4% — Agevolata" },
  { value: 0, label: "0% — Non imponibile / esente / reverse charge (richiede Natura)" },
];

// --- Codici Natura FatturaPA v1.2.2 (per operazioni con AliquotaIVA = 0)
export const NATURA_CODES = [
  { value: "", label: "-- Nessuna --" },
  { value: "N1", label: "N1 — Escluse ex art. 15 DPR 633/72" },
  { value: "N2.1", label: "N2.1 — Non soggette (artt. 7-7septies DPR 633/72)" },
  { value: "N2.2", label: "N2.2 — Non soggette — altri casi" },
  { value: "N3.1", label: "N3.1 — Non imponibili — esportazioni" },
  { value: "N3.2", label: "N3.2 — Non imponibili — cessioni intracomunitarie" },
  { value: "N3.3", label: "N3.3 — Non imponibili — cessioni verso San Marino" },
  { value: "N3.4", label: "N3.4 — Non imponibili — assimilate ad esportazioni" },
  { value: "N3.5", label: "N3.5 — Non imponibili — dichiarazioni d'intento" },
  { value: "N3.6", label: "N3.6 — Non imponibili — altre operazioni" },
  { value: "N4",   label: "N4 — Esenti" },
  { value: "N5",   label: "N5 — Regime del margine / IVA non esposta" },
  { value: "N6.1", label: "N6.1 — Reverse charge — rottami e materiali di recupero" },
  { value: "N6.2", label: "N6.2 — Reverse charge — oro e argento puro" },
  { value: "N6.3", label: "N6.3 — Reverse charge — subappalto edile" },
  { value: "N6.4", label: "N6.4 — Reverse charge — cessione di fabbricati" },
  { value: "N6.5", label: "N6.5 — Reverse charge — cessione di telefoni cellulari" },
  { value: "N6.6", label: "N6.6 — Reverse charge — cessione di prodotti elettronici" },
  { value: "N6.7", label: "N6.7 — Reverse charge — prestazioni edilizia" },
  { value: "N6.8", label: "N6.8 — Reverse charge — settore energetico" },
  { value: "N6.9", label: "N6.9 — Reverse charge — altri casi (TD17/TD18/TD19)" },
  { value: "N7",   label: "N7 — IVA assolta in altro Stato UE" },
];

// --- Regimi fiscali FatturaPA (per il cessionario italiano)
export const REGIMI_FISCALI = [
  { value: "RF01", label: "RF01 — Ordinario" },
  { value: "RF02", label: "RF02 — Contribuenti minimi (art.1, c.96-117, L.244/07)" },
  { value: "RF04", label: "RF04 — Agricoltura e attività connesse" },
  { value: "RF05", label: "RF05 — Vendita sali e tabacchi" },
  { value: "RF06", label: "RF06 — Commercio dei fiammiferi" },
  { value: "RF07", label: "RF07 — Editoria" },
  { value: "RF08", label: "RF08 — Gestione servizi telefonia pubblica" },
  { value: "RF09", label: "RF09 — Rivendita documenti di trasporto pubblico" },
  { value: "RF10", label: "RF10 — Intrattenimenti e giochi" },
  { value: "RF11", label: "RF11 — Agenzie di viaggi e turismo" },
  { value: "RF12", label: "RF12 — Agriturismo" },
  { value: "RF13", label: "RF13 — Vendite a domicilio" },
  { value: "RF14", label: "RF14 — Rivendita beni usati / oggetti d'arte" },
  { value: "RF15", label: "RF15 — Agenzie di vendite all'asta di oggetti d'arte" },
  { value: "RF16", label: "RF16 — IVA per cassa PA" },
  { value: "RF17", label: "RF17 — IVA per cassa (art.32-bis DL 83/12)" },
  { value: "RF19", label: "RF19 — Forfettario (L.190/2014)" },
  { value: "RF18", label: "RF18 — Altro" },
];

// --- Province italiane (110 sigle ISO 3166-2:IT)
export const ITALIAN_PROVINCES = [
  { code: "AG", name: "Agrigento" }, { code: "AL", name: "Alessandria" }, { code: "AN", name: "Ancona" },
  { code: "AO", name: "Aosta" }, { code: "AR", name: "Arezzo" }, { code: "AP", name: "Ascoli Piceno" },
  { code: "AT", name: "Asti" }, { code: "AV", name: "Avellino" }, { code: "BA", name: "Bari" },
  { code: "BT", name: "Barletta-Andria-Trani" }, { code: "BL", name: "Belluno" }, { code: "BN", name: "Benevento" },
  { code: "BG", name: "Bergamo" }, { code: "BI", name: "Biella" }, { code: "BO", name: "Bologna" },
  { code: "BZ", name: "Bolzano" }, { code: "BS", name: "Brescia" }, { code: "BR", name: "Brindisi" },
  { code: "CA", name: "Cagliari" }, { code: "CL", name: "Caltanissetta" }, { code: "CB", name: "Campobasso" },
  { code: "CE", name: "Caserta" }, { code: "CT", name: "Catania" }, { code: "CZ", name: "Catanzaro" },
  { code: "CH", name: "Chieti" }, { code: "CO", name: "Como" }, { code: "CS", name: "Cosenza" },
  { code: "CR", name: "Cremona" }, { code: "KR", name: "Crotone" }, { code: "CN", name: "Cuneo" },
  { code: "EN", name: "Enna" }, { code: "FM", name: "Fermo" }, { code: "FE", name: "Ferrara" },
  { code: "FI", name: "Firenze" }, { code: "FG", name: "Foggia" }, { code: "FC", name: "Forlì-Cesena" },
  { code: "FR", name: "Frosinone" }, { code: "GE", name: "Genova" }, { code: "GO", name: "Gorizia" },
  { code: "GR", name: "Grosseto" }, { code: "IM", name: "Imperia" }, { code: "IS", name: "Isernia" },
  { code: "SP", name: "La Spezia" }, { code: "AQ", name: "L'Aquila" }, { code: "LT", name: "Latina" },
  { code: "LE", name: "Lecce" }, { code: "LC", name: "Lecco" }, { code: "LI", name: "Livorno" },
  { code: "LO", name: "Lodi" }, { code: "LU", name: "Lucca" }, { code: "MC", name: "Macerata" },
  { code: "MN", name: "Mantova" }, { code: "MS", name: "Massa-Carrara" }, { code: "MT", name: "Matera" },
  { code: "ME", name: "Messina" }, { code: "MI", name: "Milano" }, { code: "MO", name: "Modena" },
  { code: "MB", name: "Monza e Brianza" }, { code: "NA", name: "Napoli" }, { code: "NO", name: "Novara" },
  { code: "NU", name: "Nuoro" }, { code: "OR", name: "Oristano" }, { code: "PD", name: "Padova" },
  { code: "PA", name: "Palermo" }, { code: "PR", name: "Parma" }, { code: "PV", name: "Pavia" },
  { code: "PG", name: "Perugia" }, { code: "PU", name: "Pesaro e Urbino" }, { code: "PE", name: "Pescara" },
  { code: "PC", name: "Piacenza" }, { code: "PI", name: "Pisa" }, { code: "PT", name: "Pistoia" },
  { code: "PN", name: "Pordenone" }, { code: "PZ", name: "Potenza" }, { code: "PO", name: "Prato" },
  { code: "RG", name: "Ragusa" }, { code: "RA", name: "Ravenna" }, { code: "RC", name: "Reggio Calabria" },
  { code: "RE", name: "Reggio Emilia" }, { code: "RI", name: "Rieti" }, { code: "RN", name: "Rimini" },
  { code: "RM", name: "Roma" }, { code: "RO", name: "Rovigo" }, { code: "SA", name: "Salerno" },
  { code: "SS", name: "Sassari" }, { code: "SV", name: "Savona" }, { code: "SI", name: "Siena" },
  { code: "SR", name: "Siracusa" }, { code: "SO", name: "Sondrio" }, { code: "SU", name: "Sud Sardegna" },
  { code: "TA", name: "Taranto" }, { code: "TE", name: "Teramo" }, { code: "TR", name: "Terni" },
  { code: "TO", name: "Torino" }, { code: "TP", name: "Trapani" }, { code: "TN", name: "Trento" },
  { code: "TV", name: "Treviso" }, { code: "TS", name: "Trieste" }, { code: "UD", name: "Udine" },
  { code: "VA", name: "Varese" }, { code: "VE", name: "Venezia" }, { code: "VB", name: "Verbano-Cusio-Ossola" },
  { code: "VC", name: "Vercelli" }, { code: "VR", name: "Verona" }, { code: "VV", name: "Vibo Valentia" },
  { code: "VI", name: "Vicenza" }, { code: "VT", name: "Viterbo" },
];

// --- Common Italian comuni (top ~200 by population + capoluogo di provincia).
// Used to power a <datalist> autocomplete on the Comune field. Users can still
// type any other comune manually.
export const COMMON_COMUNI = [
  "Roma","Milano","Napoli","Torino","Palermo","Genova","Bologna","Firenze","Bari","Catania",
  "Verona","Venezia","Messina","Padova","Trieste","Brescia","Taranto","Prato","Parma","Reggio Calabria",
  "Modena","Reggio Emilia","Perugia","Livorno","Ravenna","Cagliari","Foggia","Rimini","Salerno","Ferrara",
  "Sassari","Latina","Giugliano in Campania","Monza","Siracusa","Bergamo","Pescara","Trento","Vicenza","Forlì",
  "Terni","Bolzano","Novara","Piacenza","Ancona","Andria","Arezzo","Udine","Cesena","Lecce",
  "Pesaro","Barletta","Alessandria","La Spezia","Pistoia","Pisa","Catanzaro","Guidonia Montecelio","Lucca","Brindisi",
  "Torre del Greco","Como","Treviso","Marsala","Grosseto","Sesto San Giovanni","Pozzuoli","Varese","Fiumicino","Casoria",
  "Asti","Cinisello Balsamo","Caserta","Gela","Aprilia","Ragusa","Pavia","Cremona","Carpi","Quartu Sant'Elena",
  "Lamezia Terme","Altamura","Imola","L'Aquila","Massa","Trapani","Viterbo","Cosenza","Potenza","Castellammare di Stabia",
  "Afragola","Vittoria","Crotone","Vigevano","Molfetta","Bitonto","Fano","Cerignola","Legnano","Manfredonia",
  "Trani","Anzio","Faenza","Matera","Savona","Benevento","Marano di Napoli","San Severo","Cuneo","Battipaglia",
  "Acerra","Portici","Ercolano","Nettuno","Chieti","Casalnuovo di Napoli","Ascoli Piceno","Velletri","Scafati","Rho",
  "Aversa","Tivoli","Foligno","Civitavecchia","Ardea","Modica","Pomezia","Formia","Frosinone","Enna",
  "Cava de' Tirreni","Nocera Inferiore","Rovigo","Sanremo","San Giorgio a Cremano","Teramo","Gubbio","Marino","Chioggia","Isernia",
  "Belluno","Sondrio","Verbania","Vercelli","Biella","Fermo","Gorizia","Pordenone","Pisticci","Termoli",
  "Aosta","Nuoro","Oristano","Iglesias","Carbonia","Frosolone","Domodossola","Aviano","San Marino","Riccione",
  "Cerveteri","Fondi","Manduria","Massafra","Grottaglie","Nardò","Copertino","Casarano","Galatina","Gallipoli",
];

export const NAZIONI_UE = [
  "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE",
  "IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE",
];
